import React from 'react';
import { useProperty } from '@spotify-internal/remote-config-integration-react';

import WarningBanner from 'components/WarningBanner/WarningBanner';
import Metatags from 'components/Metatags/Metatags';
import { Banner, ParentCategory, QuickLink } from 'lib/sanity/types';
import { useTranslation } from 'providers/translations/TranslationProvider';
import PageContainer from 'components/PageContainer';
import { useUbiHomePage } from 'utils/ubi/pages/useUbiHome';
import { enableQuickLinksInSearch } from 'utils/remote-config/properties';

import Search from '../Search';
import Greetings from '../Greetings';
import CategoryCards from '../CategoryCards';
import QuickLinks from '../QuickLinks';
import Community from '../CommunitySection';

export interface HomepageProps {
  data: {
    quickLinks?: QuickLink[];
    categories?: ParentCategory[];
    banner?: Banner;
  };
}

const Home = ({ data: { quickLinks = [], categories = [], banner } }: HomepageProps) => {
  const { t } = useTranslation();
  const ubi = useUbiHomePage();
  const showQuicklinksBelow = !useProperty(enableQuickLinksInSearch);

  return (
    <>
      <Metatags desc={t('description_home_default')} />
      <WarningBanner banner={banner} />
      <PageContainer>
        <Greetings ubi={ubi} />
        <Search quickLinks={quickLinks} ubi={ubi} />
        <CategoryCards categories={categories} ubi={ubi} />
      </PageContainer>

      {showQuicklinksBelow && <QuickLinks quickLinks={quickLinks} ubi={ubi} />}
      <Community ubi={ubi} />
    </>
  );
};

export default Home;
